import React, { useCallback, useState } from 'react';
import { RefreshCw } from 'lucide-react';
interface RefreshButtonProps {
  onRefresh?: () => Promise<void> | void;
  size?: 'xs' | 'sm';
  label?: string;
}
export function RefreshButton({
  onRefresh,
  size = 'xs',
  label
}: RefreshButtonProps) {
  const [spinning, setSpinning] = useState(false);
  const handleClick = useCallback(async () => {
    if (spinning) return;
    setSpinning(true);
    try {
      await onRefresh?.();
    } catch (e) {
      console.error('[RefreshButton]', e);
    }
    // Minimum spin time for visual feedback
    setTimeout(() => setSpinning(false), 600);
  }, [onRefresh, spinning]);
  const iconSize = size === 'xs' ? 11 : 13;
  const padding = size === 'xs' ? 'p-1' : 'p-1.5';
  return <button onClick={handleClick} disabled={spinning} className={`${padding} rounded-md text-slate-600 hover:text-indigo-400 hover:bg-slate-800 transition-all duration-150 flex items-center gap-1 group`} title="Refrescar" data-id="element-2552">
      <RefreshCw size={iconSize} className={`transition-transform duration-500 ${spinning ? 'animate-spin text-indigo-400' : 'group-hover:rotate-45'}`} data-id="element-2553" />

      {label && <span className={`text-[10px] font-medium ${spinning ? 'text-indigo-400' : ''}`} data-id="element-2554">
          {label}
        </span>}
    </button>;
}